import { useAuth } from '../../contexts/AuthContext';
import { Users, FileText, MessageSquare, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const AdminDashboard = () => {
  const { user, isAdmin } = useAuth();

  const adminCards = [
    { 
      title: 'Mitarbeiter', 
      description: 'Team verwalten, Bilder und Namen anpassen',
      icon: Users, 
      link: '/admin/team',
      roles: ['admin']
    },
    { 
      title: 'Behandlungsfelder', 
      description: 'Behandlungen und Texte bearbeiten',
      icon: FileText, 
      link: '/admin/treatments',
      roles: ['admin']
    },
    { 
      title: 'Popup-Fenster', 
      description: 'Ankündigungen planen und verwalten',
      icon: MessageSquare, 
      link: '/admin/popups',
      roles: ['admin', 'user']
    },
    { 
      title: 'Kontaktdaten', 
      description: 'Telefon, E-Mail und Öffnungszeiten',
      icon: Phone, 
      link: '/admin/contact',
      roles: ['admin', 'user']
    },
  ];

  const filteredCards = adminCards.filter(card => card.roles.includes(user?.role));

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold" style={{ color: '#1B4D3E' }}>
          Willkommen, {user?.username}!
        </h1>
        <p className="text-gray-500 mt-2">
          {isAdmin() 
            ? 'Sie haben vollen Zugriff auf alle Admin-Funktionen.'
            : 'Sie können Popup-Fenster und Kontaktdaten verwalten.'}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredCards.map((card) => (
          <Link
            key={card.link}
            to={card.link}
            className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-shadow border border-gray-100"
          >
            <div 
              className="w-12 h-12 rounded-lg flex items-center justify-center mb-4"
              style={{ backgroundColor: '#e8f0ed' }}
            >
              <card.icon className="w-6 h-6" style={{ color: '#1B4D3E' }} />
            </div>
            <h3 className="text-lg font-semibold mb-2" style={{ color: '#1B4D3E' }}>
              {card.title}
            </h3>
            <p className="text-gray-500 text-sm">{card.description}</p>
          </Link>
        ))}
      </div>

      <div className="mt-8 bg-white rounded-xl p-6 shadow-sm border border-gray-100">
        <h2 className="text-xl font-semibold mb-4" style={{ color: '#1B4D3E' }}>
          Schnellzugriff
        </h2>
        <div className="flex flex-wrap gap-4">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 rounded-lg text-white"
            style={{ backgroundColor: '#1B4D3E' }}
          >
            Website ansehen
          </a>
          <a
            href="https://www.doctolib.de/zahnarztpraxis/dachau/zahnarztpraxis-andrei-guenter-muresan-richter"
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 rounded-lg border"
            style={{ borderColor: '#1B4D3E', color: '#1B4D3E' }}
          >
            Doctolib öffnen
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
